"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _utils = require("@/utils");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "batchReservationPh",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    edoCreditId: {
      type: String,
      default: ''
    },
    vvLBlNo: {
      type: String,
      default: ''
    },
    del: {
      type: String,
      default: ''
    },
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    forespeakBlNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    forespeakStatus: {
      type: Number,
      default: 0
    },
    forespeakStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ecmNgbEdoOwnerType: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: null,
      form: {
        blNo: '',
        forespeakBlNo: [],
        ownerType: "",
        identifier: "",
        consigneeName: "",
        consigneeAddress: ""
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {},
  methods: {
    handleCancel: function handleCancel() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.cancelForespeak)(this.form.edoCreditId).then(function (res) {
        if (res.success) {
          _this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.form), res.data);
          _this.$message({
            message: _this.$t('blExchangeAppointment.cancelReservationSuccess'),
            type: 'success'
          });
          _this.closed();
        } else {
          _this.$message.error(_this.$t('blExchangeAppointment.cancelReservationFail'));
        }
        _this.closed();
      }).catch(function (err) {}).finally(function () {
        _this.loading.close();
      });
    },
    handleNext: function handleNext() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.loading = (0, _utils.load)();
          _this2.form.forespeakBlNo = _this2.forespeakBlNo;
          (0, _blExchangeAppointment.saveForespeak)(_this2.form).then(function (res) {
            if (res.success) {
              _this2.closed();
            } else {
              _this2.$message.error(_this2.$t('blExchangeAppointment.reservationFailure'));
            }
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
      this.$emit('handleNextContainer');
    },
    opened: function opened() {
      var _this3 = this;
      if (this.edoCreditId) {
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointment.getForespeakAction)(this.edoCreditId, this.del).then(function (res) {
          if (res.success) {
            _this3.form = res.data;
          }
        }).catch(function (error) {}).finally(function () {
          _this3.loading.close();
        });
      } else {
        this.$set(this.form, 'paymentStatus', this.paymentStatus);
        this.$set(this.form, 'forespeakStatus', this.forespeakStatus);
      }
    },
    closed: function closed() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.form.resetFields();
      });
      this.$emit('update:visible', false);
    }
  }
};